"use client";

import classnames from "classnames";

import styles from "./segmented-control.module.scss";

export interface SegmentedControlProps<T extends string> {
  options: Array<{ value: T; label: string }>;
  value: T;
  onChange: (value: T) => void;
  "data-testid"?: string;
}

export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  "data-testid": testId,
}: SegmentedControlProps<T>) {
  return (
    <div className={styles.control} data-testid={testId} role="radiogroup">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={classnames(styles.option, value === opt.value && styles.active)}
          onClick={() => onChange(opt.value)}
          role="radio"
          aria-checked={value === opt.value}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
